import axios from "axios";
import { useEffect } from "react";
import io from "socket.io-client";

const Test = () => {
  useEffect(() => {
    const socket = io("http://127.0.0.1:30000");
    // Emitir un mensaje al servidor
    socket.emit("broadcast_message", "Message sent from udp2ws");

    // Escuchar eventos del servidor
    socket.on("car_info", (data: any) => {
      console.log(data);
    });
    socket.on("car_update", (data: any) => {
      console.log(data);
    });
    socket.on("client_loaded", (data: any) => {
      console.log(data);
    });
    socket.on("collision_with_car", (data: any) => {
      console.log(data);
    });
    socket.on("lap_completed", (data: any) => {
      console.log(data);
    });
    socket.on("new_session", (data: any) => {
      console.log(data);
    });
    socket.on("session_info", (data: any) => {
      console.log(data);
    });
    socket.on("server_error", (data: any) => {
      console.log(data);
    });
    socket.on("console", (messageObject: any) => {
      console.log(messageObject);
    });

    /*axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/admin/test`
      )
      .then(({ data }) => {
        console.log(data);
      })
      .catch(({ response }) => {
        throw new Error(response);
      });*/
  }, []);

  return <label>a</label>;
};

export default Test;
